
// left pad
// 10.pad(4) => "0040"
Number.prototype.pad = function (len) {
    return (new Array(len+1).join("0") + this).slice(-len);
}